export class NavigationSidebar {
  constructor() {
    this.sidebar = document.getElementById('js-navigation-sidebar')
    if (this.sidebar === null) return
    if (window.innerWidth < 768) {
      const sidebarParent = this.sidebar.parentNode
      sidebarParent.parentNode.removeChild(sidebarParent)
    }
    this.titles = [...document.getElementsByClassName('js-navigation-sidebar-title')]
    if (this.sidebar === null || this.titles.length === 0) return
    this.sidebarItems = []
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const { id } = entry.target.dataset
          if (entry.isIntersecting) {
            this.sidebarItems[Number(id)].classList.add('is-act')
          } else {
            this.sidebarItems[Number(id)].classList.remove('is-act')
          }
        })
      },
      { threshold: 0, root: null, rootMargin: '-50% 0px' }
    )
    this.sections = this.titles.map((title, i) => {
      const section = title.closest('.js-navigation-sidebar-item')
      const li = document.createElement('li')
      const anchor = document.createElement('a')
      const span = document.createElement('span')
      section.dataset.id = i
      span.textContent = title.textContent
      anchor.appendChild(span)
      anchor.setAttribute('href', '#section' + i)
      li.appendChild(anchor)
      this.sidebar.appendChild(li)
      this.sidebarItems.push(li)
      section.setAttribute('id', 'section' + i)
      intersectionObserver.observe(section)
      return section
    })
  }
}
